import React, { useContext } from 'react';

import Email from 'app/components/Form/Email';

import { ConfigContext } from '../../ConfigProvider';

import '../checkout-ny.scss';


export function CheckoutEmail(props) {
    const {
        emailValue,
        handleChangeEmail,
        handleBlurEmail,
        hasEmailError,
        emailErrorText,
    } = props;

    const {
        pageId,
    } = useContext(ConfigContext);

    if (pageId !== 'gift') {
        return null;
    }

    const style = hasEmailError ? { marginBottom: 20 } : {};

    return (
        <>
            <div styleName="checkout__input-wrap" style={style}>
                <Email
                    value={emailValue}
                    onChange={handleChangeEmail}
                    onBlur={handleBlurEmail}
                    hasError={hasEmailError}
                    errorText={emailErrorText}
                />
            </div>
            <div styleName="checkout__input-wrap">
                <p className="ny__set__description" style={{ width: '100%', textAlign: 'center' }}>
                    Сертификат отправим в&nbsp;электронном виде, но&nbsp;мы&nbsp;технически
                    не&nbsp;можем без адреса и&nbsp;времени&nbsp;доставки&nbsp;:(
                </p>
            </div>
        </>
    );
}
